import { AxiosError } from 'axios'
import { HttpClientConfig } from '../../../useHttpClientConfig'
import { apiVersion, service } from '../service'
import { FilterValue, applySearchParams, urlToPathnameAndSearch } from '../utils'
import { GetAvailabilitiesRequest } from './index'

interface ResourceDayAvailability {
  isAvailable: boolean
}

type DayKey = string // ISO date string (YYYY-MM-DD)
type ResourceId = string

interface AsegoDaysResponse {
  dayAvailability: Record<DayKey, Record<ResourceId, ResourceDayAvailability>>
  responseStatus: number
  resourceHasCalendarIntegration: Record<ResourceId, boolean>
}

const pathname = `/api/${apiVersion}/availabilities/days`

const makeGetAvailableDays =
  (baseUrl: string, config: HttpClientConfig) =>
  async (request: GetAvailabilitiesRequest): Promise<AsegoDaysResponse> => {
    const url = new URL(pathname, baseUrl)

    applySearchParams(url, request as unknown as Record<string, FilterValue>)

    const pathnameAndSearch = urlToPathnameAndSearch(url)
    const payload = await service(baseUrl)
      .get<AsegoDaysResponse>(pathnameAndSearch, config)
      .then((response): AsegoDaysResponse => ({ ...response.data, responseStatus: response?.status }))
      .catch((error: AxiosError): AsegoDaysResponse => {
        return {
          dayAvailability: {},
          responseStatus: error?.response?.status || 500,
          resourceHasCalendarIntegration: {},
        }
      })
    return payload
  }

export { makeGetAvailableDays }
export type { AsegoDaysResponse, ResourceDayAvailability }
